import React, { useState } from "react";
import peliculas from "../db.json";
import { useParams } from "react-router-dom";
import estilo from "../styles/Detalles.module.css";
import MetaDecorator from "../utils/MetaDecorator";
import Comentarios from "../components/Comentarios";
import Paginacion from "../components/Paginacion";

function SeriesDetalles() {
  const params = useParams();
  const numeroP = params.id;
  // console.log(numeroP);
  const recorrido = peliculas
    .map(({ ...capitulos }) => ({ ...capitulos }))
    .find((e) => e.id === numeroP);
  // console.log(recorrido);
  const capVer = recorrido.capitulos.map(({ ...servidores }) => ({
    ...servidores,
  }));
  // console.log(capVer);
  const [elementoPagina, setElementoPagina] = useState(1);
  const [elementosPorPagina] = useState(1);
  const ultimoIndice = elementoPagina * elementosPorPagina;
  const primerIndice = ultimoIndice - elementosPorPagina;
  //
  const elementosSalidaCap = capVer.slice(primerIndice, ultimoIndice);
  const paginacion = (numeroPagina) => setElementoPagina(numeroPagina);
  // console.log(elementosSalidaCap);
  return (
    <div className={estilo.detalles}>
      <MetaDecorator
        titulo={"Ver " + recorrido.titulo + " en linea | RepelisPlus"}
        subtitulo={recorrido.titulo}
        descripcion={recorrido.sinopsis}
      />

      <div className={estilo.linea}></div>
      <div className={estilo.detalles_pelicula}>
        <div className={estilo.detalles_portada}>
          <img src={recorrido.portada} alt={recorrido.titulo} />
        </div>

        <div className={estilo.detalles_informacion}>
          <div className={estilo.informacion_a}>
            <h2>{recorrido.titulo}</h2>

            <div className={estilo.fecha_duracion}>
              <span>{recorrido.año}</span>
              <span>Temporada {recorrido.duracion}</span>
            </div>
          </div>

          <div className={estilo.informacion_b}>
            <p>
              <b>Calificación: </b>
              {recorrido.calificacion}
            </p>
          </div>

          <div className={estilo.informacion_c}>
            <h3>{recorrido.titulo} | PelisPlus.com</h3>
            <span>
              <b>Géneros: </b>
              {recorrido.generos.map((g) => g.nombre).join(", ")}
            </span>
            <p>
              <b>Sinopsis: </b>
              {recorrido.sinopsis}
            </p>
          </div>
        </div>
      </div>

      <div className={estilo.serie}>
        {elementosSalidaCap.map((e) => (
          <div className={estilo.detalles_serie}>
            <h3 key={e.id}>{e.capitulo}</h3>
            {e.servidores.map((e, i) => (
              <div key={i}>
                <iframe
                  className={estilo.reproductor}
                  width="560"
                  height="315"
                  src={e.servidor}
                  title={e.nombre}
                  frameborder="0"
                  allowfullscreen="true"
                ></iframe>
              </div>
            ))}
            <Paginacion
              elementosPorPagina={elementosPorPagina}
              elementosTotales={capVer.length}
              paginacion={paginacion}
              pag="cap"
            />
          </div>
        ))}
      </div>

      <Comentarios></Comentarios>
    </div>
  );
}

export default SeriesDetalles;
